import type { KnowledgeArticleTranslations } from './articles.types';

export const KNOWLEDGE_BASE_ARTICLES_SI: KnowledgeArticleTranslations = {
  pickup: {
    title: 'එකතු කිරීමේ ඇණවුම්',
    summary: "එකතු කිරීමේ ඇණවුම් සාදන්න, නිරීක්ෂණය කරන්න සහ කළමනාකරණය කරන්න.",
    content:
      'එකතු කිරීමේ ඇණවුම් ඔබේ අඩවිවලින් කසළ එකතු කිරීමේ කාලසටහන සකස් කිරීමට භාවිතා වේ. පැති තීරුවෙන් «එකතු කිරීමේ ඇණවුම්» විවෘත කර නව ඇණවුමක් සාදන්න, ලැයිස්තුව බලන්න හෝ ඒවායේ තත්වය නිරීක්ෂණය කරන්න.\n\nපියවරෙන් පියවර උපදෙස් සඳහා පහත මාර්ගෝපදේශයක් තෝරන්න.',
  },
  'view-pickup-orders-list': {
    title: "එකතු කිරීමේ ඇණවුම් ලැයිස්තුව බලන්න",
    summary: "ඇණවුම් වගුව විවෘත කරන්න, සොයන්න සහ ඉල්ලීම් බලන්න.",
    content:
      "1. පැති තීරුවෙන් «එකතු කිරීමේ ඇණවුම්» විවෘත කරන්න.\n\n2. ප්‍රධාන වගුවේ ඔබේ සංවිධානයේ ඇණවුම් ID, එකතු කිරීමේ ස්ථානය, තත්ත්වය සහ දින සමඟ පෙන්වයි.\n\n3. ID හෝ ස්ථානය අනුව සෙවීමට වගුවට ඉහළින් ඇති සෙවුම් කොටුව භාවිතා කරන්න.\n\n4. තවත් පේළි බැලීමට ස්ක්‍රෝල් කර පහළ පිටුකරණය භාවිතා කරන්න.\n\nඉඟිය: තත්ත්ව චිප්ස් සහ දින පෙරහන් ප්‍රතිඵල සීමා කරයි — අදාළ මාර්ගෝපදේශ බලන්න.",
  },
  'create-pickup-order-outlet': {
    title: 'නව එකතු කිරීමේ ඇණවුමක් සාදන්න',
    summary: "අපද්‍රව්‍ය එකතු කිරීම කාලසටහන්ගත කිරීමට පියවරෙන් පියවර මාර්ගෝපදේශය.",
    content:
      '1. පැති තීරුවෙන් «එකතු කිරීමේ ඇණවුම්» විවෘත කර «එකතු කිරීමේ ඇණවුම සාදන්න» (හෝ එකතු කිරීමේ ඇණවුම් පිටුවේ + බොත්තම ඔබන්න) තෝරන්න.\n\n2. ඇණවුම් විස්තර:\n   • ද්‍රව්‍ය වර්ගය (අනිවාර්ය) — කසළ කාණ්ඩය සහ මිනුම් ඒකකය ස්වයංක්‍රීයව පුරවනු ලැබේ.\n\n3. ස්ථානය සහ කන්ටෙයිනරය:\n   • එකතු කිරීමේ ස්ථානය (අනිවාර්ය)\n   • තෝරන ලද ස්ථානයේ කන්ටෙයිනරය\n   • පිරවුම් මට්ටම — සම්පූර්ණ, තුනේ හතරෙන් තුන, අර්ධ, හෝ හතරෙන් එක\n\n4. «සුරකින්න» ඔබන්න. ඇණවුම «පොරොත්තුවෙන්» තත්වයෙන් ලැයිස්තුවේ දිස්වේ.',
  },
  material: {
    title: 'ද්‍රව්‍ය',
    summary: "එකතු කිරීමේ ඇණවුම් සඳහා ද්‍රව්‍ය වර්ග එකතු කරන්න, සංස්කරණය සහ කළමනාකරණය කරන්න.",
    content:
      'ද්‍රව්‍ය වර්ග එකතු කිරීම සහ සංස්කරණය කිරීමේ ක්‍රමය දැනගැනීමට පහත මාර්ගෝපදේශයක් තෝරන්න.',
  },
  'add-material-type': {
    title: 'ද්‍රව්‍ය වර්ගයක් එකතු කරන්න',
    summary: "එකතු කිරීමේ ඇණවුම් සඳහා අපද්‍රව්‍ය ද්‍රව්‍ය වර්ගයක් ලියාපදිංචි කරන්න.",
    content:
      '1. පැති තීරුවෙන් «ප්‍රතිචක්‍රීකරණය» විවෘත කර «ද්‍රව්‍ය වර්ග» තෝරන්න.\n\n2. «ද්‍රව්‍ය එකතු කරන්න» (ඉහළ දකුණ) ඔබන්න.\n\n3. ද්‍රව්‍ය නාමය, කාණ්ඩය සහ මිනුම් ඒකකය ඇතුළත් කරන්න (උදා: කි.ග්‍රෑ, ටොන්, බෑග්).\n\n4. «සුරකින්න» ඔබන්න. එකතු කිරීමේ ඇණවුම් සාදන විට ද්‍රව්‍යය ලබා ගත හැක.',
  },
  container: {
    title: 'කන්ටෙයිනර',
    summary: "අපද්‍රව්‍ය බහාලුම් එකතු කරන්න, කළමනාකරණය සහ නිරීක්ෂණය කරන්න.",
    content:
      'කන්ටෙයිනර කළමනාකරණය කිරීමේ ක්‍රමය දැනගැනීමට පහත මාර්ගෝපදේශයක් තෝරන්න.',
  },
  'add-container': {
    title: 'නව කන්ටෙයිනරයක් එකතු කරන්න',
    summary: "එකතු කිරීමේ ස්ථානයක අපද්‍රව්‍ය බහාලුමක් ලියාපදිංචි කරන්න.",
    content:
      '1. පැති තීරුවෙන් «කන්ටෙයිනර» විවෘත කර «කන්ටෙයිනර ලැයිස්තුව» තෝරන්න.\n\n2. «කන්ටෙයිනර එකතු කරන්න» (ඉහළ දකුණ) ඔබන්න.\n\n3. කන්ටෙයිනර විස්තර පුරවන්න: නාමය, ද්‍රව්‍ය වර්ගය, එකතු කිරීමේ ස්ථානය, තත්වය සහ අනිවාර්ය ක්ෂේත්‍ර.\n\n4. «සුරකින්න» ඔබන්න. කන්ටෙයිනරය ලැයිස්තුවේ දිස්වන අතර එකතු කිරීමේ ඇණවුම් සාදන විට තෝරා ගත හැක.',
  },
  'collection-site': {
    title: 'එකතු කිරීමේ ස්ථාන',
    summary: "අපද්‍රව්‍ය එකතු කිරීමේ ස්ථාන එකතු කරන්න, සංස්කරණය සහ කළමනාකරණය කරන්න.",
    content:
      'එකතු කිරීමේ ස්ථාන කළමනාකරණය කිරීමේ ක්‍රමය දැනගැනීමට පහත මාර්ගෝපදේශයක් තෝරන්න.',
  },
  'add-collection-site': {
    title: 'නව එකතු කිරීමේ ස්ථානයක් එකතු කරන්න',
    summary: "අපද්‍රව්‍ය එකතු කරන ස්ථානයක් සාදන්න.",
    content:
      '1. පැති තීරුවෙන් «කන්ටෙයිනර» විවෘත කර «එකතු කිරීමේ ස්ථාන» තෝරන්න.\n\n2. «ස්ථානය එකතු කරන්න» (ඉහළ දකුණ) ඔබන්න.\n\n3. ස්ථාන නාමය, ලිපිනය සහ අවශ්‍ය විස්තර ඇතුළත් කරන්න.\n\n4. «සුරකින්න» ඔබන්න. ඉන්පසු කන්ටෙයිනර මෙම ස්ථානයට සම්බන්ධ කර එකතු කිරීමේ ඇණවුම් පෝරමවල තෝරා ගත හැක.',
  },

  truck: {
    title: 'ට්‍රක්',
    summary: "වාහන එකතු කරන්න, යාත්‍රා තත්ත්ව තේරුම් ගෙන ට්‍රක් කළමනාකරණය කරන්න.",
    content:
      'වාහන නාළිගාව කළමනාකරණය කිරීමේ ක්‍රමය දැනගැනීමට පහත මාර්ගෝපදේශයක් තෝරන්න.',
  },
  'add-vehicle': {
    title: 'වාහනයක් එකතු කරන්න',
    summary: "සම්පූර්ණ විස්තර සමඟ නව ට්‍රක් හෝ යාත්‍රා වාහනයක් ලියාපදිංචි කරන්න.",
    content:
      '1. පැති තීරුවෙන් «ට්‍රක්» විවෘත කර «නාළිගා කළමනාකරණය» වෙත පිවිසෙන්න.\n\n2. «වාහනය එකතු කරන්න» (ඉහළ දකුණ) ඔබන්න.\n\n3. පෝරමය පුරවන්න:\n   • අංක පුවරු (අරාබි සහ ඉංග්‍රීසි)\n   • වාහන නාමය (අනිවාර්ය)\n   • ධාරිතාව සහ ධාරිතා ඒකකය\n   • වාහන වර්ගය, මාදිලිය, VIN, හිස් බර සහ ඉන්ධන පරිභෝජනය\n   • තත්වය — වාහනය පවරා ගැනීමට සූදානම් නම් «ලබා ගත හැක» තෝරන්න\n\n4. «සුරකින්න» ඔබන්න. වාහනය නාළිගා වගුවේ දිස්වේ.',
  },
  driver: {
    title: 'රියදුරු',
    summary: "රියදුරන් ලියාපදිංචි කරන්න, පැතිකඩ බලන්න සහ ට්‍රක් පැවරුම් කළමනාකරණය කරන්න.",
    content:
      'රියදුරන් කළමනාකරණය කිරීමේ ක්‍රමය දැනගැනීමට පහත මාර්ගෝපදේශයක් තෝරන්න.',
  },
  'add-driver': {
    title: 'රියදුරෙකු එකතු කරන්න',
    summary: "බලපත්‍රය සහ පුද්ගලික විස්තර සමඟ රියදුරු ගිණුමක් සාදන්න.",
    content:
      '1. පැති තීරුවෙන් «රියදුරු» විවෘත කරන්න.\n\n2. «රියදුරු එකතු කරන්න» (ඉහළ දකුණ) ඔබන්න.\n\n3. ගිණුම් කොටස: විද්‍යුත් තැපෑල, මුරපදය සහ එහි තහවුරු කිරීම.\n\n4. පුද්ගලික කොටස: නාමය, දුරකථන අංකය, ස්ත්‍රී පුරුෂ භාවය, ජාතිකත්වය සහ වෙනත්.\n\n5. රියදුරු සහ වාහන කොටස: රියදුරු බලපත්‍ර අංකය, කල් ඉකුත් වන දිනය සහ වාහන ලියාපදිංචි අංකය.\n\n6. «සුරකින්න» ඔබන්න. රියදුරු වගුවේ දිස්වේ.',
  },
  'understanding-notifications': {
    title: 'දැනුම්දීම්',
    summary: "වේදිකා ඇඟවීම් සක්‍රිය කිරීම, කියවීම සහ කළමනාකරණය කරන ආකාරය.",
    content:
      'බ්‍රවුසර් දැනුම්දීම් සක්‍රීය කරන්න:\nඅවසර ඉල්ලීම පෙනෙන විට «ඉඩ දෙන්න» ඔබන්න, යෙදුමෙන් පිටත ඇණවුම් සහ වේදිකා යාවත්කාලීන ලබා ගැනීමට.\n\nදැනුම්දීම් බලන්න:\n1. ඉහළ තීරුවේ සීනු අයිකනය ඔබන්න.\n2. පැනලය නොකියවූ දැනුම්දීම් මාතෘකාව, පණිවිඩය සහ වේලාව සමග පෙන්වයි.\n3. දැනුම්දීමක් ඔබා කියවූ ලෙස සලකුණු කරන්න.\n4. «සියල්ල කියවූ ලෙස සලකුණු කරන්න» භාවිතා කර සියලු නොකියවූ දැනුම්දීම් එකවර මකන්න.\n\nවැදගත්:\n• සීනුවේ දිස්වන අංකය නොකියවූ දැනුම්දීම් ගණන දක්වයි.',
  },
  'pickup-order-statuses': {
    title: 'එකතු කිරීමේ ඇණවුම් තත්වය',
    summary: "මෙහෙයුම් හරහා ගමන් කරන විට සෑම ඇණවුම් තත්ත්වයකම අර්ථය.",
    content:
      '«එකතු කිරීමේ ඇණවුම්» ලැයිස්තුවෙන් වර්තමාන තත්වය බලන්න. ඇණවුම් ප්‍රගතිය සමග තත්වය ස්වයංක්‍රීයව යාවත්කාලීන වේ.\n\n• පොරොත්තුවෙන් — ඇණවුම සාදන ලද අතර සැකසීම හෝ පවරා ගැනීම බලාපොරොත්තුවෙන්.\n• ප්‍රවාහනයේ — කසළ එකතු කිරීම හෝ ප්‍රවාහනය සිදුවෙමින්.\n• සම්පූර්ණ — ඇණවුම සාර්ථකව සම්පූර්ණ විය.\n• අවලංගු — ඇණවුම අවලංගු කරන ලද අතර සම්පූර්ණ නොවේ.',
  },
  'filter-pickup-orders-by-date': {
    title: 'දිනය අනුව ඇණවුම් පෙරහන් කරන්න',
    summary: "නිශ්චිත දින පරාසයක් තුළ ඇණවුම් සොයන්න.",
    content:
      '1. පැති තීරුවෙන් «එකතු කිරීමේ ඇණවුම්» විවෘත කරන්න.\n\n2. «දිනය අනුව පෙරහන» කොටස වෙත යන්න.\n\n3. ආරම්භක සහ අවසාන දින සකස් කරන්න.\n\n4. ලැයිස්තුව පෙරහන් කිරීමට «දින යොදන්න» ඔබන්න.\n\n5. පෙරහන ඉවත් කර පෙරනිමි දර්ශනයට ආපසු යාමට «දින මකන්න» ඔබන්න.',
  },
  'container-fill-level': {
    title: 'කන්ටෙයිනර පිරවුම් මට්ටම',
    summary: "බහාලුමක් සඳහා නිවැරදි පිරවුම් මට්ටම තෝරන ආකාරය.",
    content:
      '«එකතු කිරීමේ ඇණවුම සාදන්න» පෝරමයේ කන්ටෙයිනරය තෝරන විට පිරවුම් මට්ටම අනිවාර්ය වේ.\n\nලබා ගත හැකි විකල්ප:\n• සම්පූර්ණ — කන්ටෙයිනරය සම්පූර්ණයෙන් පිරී ඇත\n• තුනේ හතරෙන් තුන — ආසන්න වශයෙන් 75% පිරී ඇත\n• අර්ධ — ආසන්න වශයෙන් 50% පිරී ඇත\n• හතරෙන් එක — ආසන්න වශයෙන් 25% පිරී ඇත\n\nසැබෑ තත්වයට ආසන්නතම මට්ටම තෝරන්න, මෙහෙයුම් සහ රියදුරන් හොඳ සැලසුම් කිරීමට උපකාරී වේ.',
  },
  'container-statuses': {
    title: 'කන්ටෙයිනර තත්වය',
    summary: "සෑම බහාලුම් තත්ත්වයකම අර්ථය සහ කවදා භාවිතා කරන්නද යන්න.",
    content:
      '«කන්ටෙයිනර ලැයිස්තුව» හරහා කන්ටෙයිනරය එකතු හෝ සංස්කරණය කරන විට තත්වය සකස් හෝ සමාලෝචනය කළ හැක.\n\n• එකතු කිරීමට සූදානම් — කන්ටෙයිනරය සූදානම් අතර කසළ එකතු කළ හැක.\n• එකතු කිරීම බලාපොරොත්තුවෙන් — එකතු කිරීම කාලසටහන් කර ඇත හෝ ක්‍රියාත්මක වීම බලාපොරොත්තුවෙන්.\n• හිස් — එකතු කිරීමට කසළ නැත.\n• නඩත්තුවේ — කන්ටෙයිනරය තාවකාලිකව සේවාවෙන් බැහැර.\n• සූදානම් වෙමින් — කන්ටෙයිනරය සකස් කරමින්.\n• අක්‍රිය — කන්ටෙයිනරය දැනට භාවිතයේ නැත.',
  },
  'print-container-qr': {
    title: 'කන්ටෙයිනර QR කේතය මුද්‍රණය කරන්න',
    summary: "ක්ෂේත්‍ර භාවිතය සඳහා QR ලේබලයක් සාදා මුද්‍රණය කරන්න.",
    content:
      '1. «කන්ටෙයිනර» ← «කන්ටෙයිනර ලැයිස්තුව» විවෘත කරන්න.\n\n2. වගුවේ කන්ටෙයිනරය සොයන්න.\n\n3. පේළියේ QR අයිකනය ඔබන්න.\n\n4. මුද්‍රණ සංවාදයෙන් ලේබලය මුද්‍රණය කරන්න.\n\nලේබලය ස්ථානයේ කන්ටෙයිනරයට අලවන්න, හඳුනාගැනීම සහ ක්ෂේත්‍ර ස්කෑන් කිරීම පහසු කිරීමට.',
  },
  'edit-material-type': {
    title: 'ද්‍රව්‍ය වර්ගය සංස්කරණය හෝ මකන්න',
    summary: "ප්‍රතිචක්‍රීකරණ සැකසුම්වලින් ද්‍රව්‍ය වර්ගය යාවත්කාලීන කරන්න හෝ ඉවත් කරන්න.",
    content:
      '1. «ප්‍රතිචක්‍රීකරණය» ← «ද්‍රව්‍ය වර්ග» විවෘත කරන්න.\n\n2. සංස්කරණයට: සංස්කරණ අයිකනය ඔබන්න, විස්තර වෙනස් කර «සුරකින්න» ඔබන්න.\n\n3. මකා දැමීමට: මකා දැමීමේ අයිකනය ඔබන්න, ක්‍රියාව තහවුරු කරන්න.\n\nඅවවාදය: සක්‍රිය එකතු කිරීමේ ඇණවුම් සමග සම්බන්ධ ද්‍රව්‍ය වර්ගය මකන්න එපා. පළමුව එම ඇණවුම් සම්පූර්ණ හෝ යාවත්කාලීන කරන්න.',
  },
  'edit-or-delete-container': {
    title: 'කන්ටෙයිනරය සංස්කරණය හෝ මකන්න',
    summary: "ලැයිස්තුවෙන් බහාලුම යාවත්කාලීන කරන්න හෝ ඉවත් කරන්න.",
    content:
      '1. «කන්ටෙයිනර» ← «කන්ටෙයිනර ලැයිස්තුව» විවෘත කරන්න.\n\n2. සංස්කරණයට: සංස්කරණ අයිකනය ඔබන්න, විස්තර වෙනස් කර «සුරකින්න» ඔබන්න.\n\n3. මකා දැමීමට: මකා දැමීමේ අයිකනය ඔබන්න, ක්‍රියාව තහවුරු කරන්න.\n\nඅවවාදය: කන්ටෙයිනරය එකතු කිරීමේ ඇණවුම් සමග සම්බන්ධ විය හැක. මකා දැමීමට පෙර තහවුරු කරන්න.',
  },
  'edit-or-delete-collection-site': {
    title: 'එකතු කිරීමේ ස්ථානය සංස්කරණය හෝ මකන්න',
    summary: "එකතු කිරීමේ ස්ථානය යාවත්කාලීන කරන්න හෝ ඉවත් කරන්න.",
    content:
      '1. «කන්ටෙයිනර» ← «එකතු කිරීමේ ස්ථාන» විවෘත කරන්න.\n\n2. ස්ථාන කාඩ්පතේ «සංස්කරණය» හෝ «මකන්න» ඔබන්න.\n\n3. ඉල්ලූ විට මකා දැමීම තහවුරු කරන්න.\n\nඅවවාදය: ස්ථානය කන්ටෙයිනර සහ එකතු කිරීමේ ඇණවුම් සමග සම්බන්ධ විය හැක. මකා දැමීමට පෙර සම්බන්ධතා සමාලෝචනය කරන්න.',
  },
  'truck-statuses': {
    title: 'වාහන තත්වය',
    summary: "සෑම යාත්‍රා වාහන තත්ත්වයකම අර්ථය සහ කවදා භාවිතා කරන්නද යන්න.",
    content:
      'සෑම වාහනයකම තත්වය «නාළිගා කළමනාකරණය» වගුවේ දිස්වේ. එකතු හෝ සංස්කරණය කරන විට යාවත්කාලීන කළ හැක.\n\n• ලබා ගත හැක — වාහනය රියදුරු හෝ ගමනක් සඳහා පවරා ගැනීමට සූදානම්.\n• ලබා ගත නොහැක — වාහනය දැනට භාවිතා කළ නොහැක.\n• ප්‍රවාහනයේ — වාහනය මාර්ගයේ.\n• පූරණය / බෑග් කිරීම — වාහනය පූරණ හෝ බෑග් කිරීමේ ස්ථානයේ.\n• නඩත්තුවේ — වාහනය අළුත්වැඩියා හෝ සේවාවේ.\n\nඋපදෙස්: තාවකාලිකව නතර වූ විට «ලබා ගත නොහැක» හෝ «නඩත්තුවේ» තබන්න, මකන්න එපා.',
  },
  'view-driver-details': {
    title: 'රියදුරු විස්තර බලන්න',
    summary: "රියදුරු පැතිකඩ, බලපත්‍ර තොරතුරු සහ පවරා ඇති ට්‍රක් විවෘත කරන්න.",
    content:
      '1. පැති තීරුවෙන් «රියදුරු» විවෘත කරන්න.\n\n2. වගුවේ රියදුරු සොයන්න.\n\n3. විස්තර විවෘත කිරීමට බලන්න (ඇස) අයිකනය ඔබන්න.\n\n4. සංවාදය පෙන්වයි: ගිණුම් තොරතුරු, පුද්ගලික විස්තර, බලපත්‍ර තොරතුරු සහ පවරන ලද ට්‍රක් ඇත්නම්.\n\n5. සංස්කරණයට: සංවාදයේ «සංස්කරණය» ඔබන්න, හෝ පේළි ක්‍රියා මෙනුව භාවිතා කරන්න.\n\nට්‍රක් «පවරා නැත» දක්වන්නේ නම් ක්‍රියා මෙනුවෙන් «ට්‍රකයට පවරන්න» තෝරන්න.',
  },
  'edit-or-delete-vehicle': {
    title: 'වාහනය සංස්කරණය හෝ මකන්න',
    summary: "වාහන විස්තර යාවත්කාලීන කරන්න හෝ යාත්‍රාවෙන් ට්‍රක් ඉවත් කරන්න.",
    content:
      'වාහනය සංස්කරණය:\n1. «ට්‍රක්» ← «නාළිගා කළමනාකරණය» විවෘත කරන්න.\n2. පේළියේ සංස්කරණ අයිකනය ඔබන්න, හෝ විස්තර විවෘත කර «සංස්කරණය» තෝරන්න.\n3. ක්ෂේත්‍ර වෙනස් කර «සුරකින්න» ඔබන්න.\n\nවාහනය මකන්න:\n1. පේළියේ මකා දැමීමේ අයිකනය ඔබන්න, හෝ විස්තරයෙන් මකන්න.\n2. මකා දැමීම තහවුරු කරන්න.\n\nඅවවාදය: රියදුරුට පවරා ඇති හෝ සක්‍රිය ගමන් සමග සම්බන්ධ වාහනය මකා දැමීමෙන් මෙහෙයුම්වලට බලපෑම් විය හැක.',
  },
  'edit-or-delete-driver': {
    title: 'රියදුරු සංස්කරණය සහ ට්‍රක් පවරා ගැනීම',
    summary: "රියදුරු තොරතුරු යාවත්කාලීන කර පවරා ඇති ට්‍රක් කළමනාකරණය කරන්න.",
    content:
      'රියදුරු විස්තර සංස්කරණය:\n1. «රියදුරු» විවෘත කරන්න.\n2. පේළි ක්‍රියා මෙනුවෙන් «රියදුරු සංස්කරණය» තෝරන්න.\n3. විස්තර වෙනස් කර «සුරකින්න» ඔබන්න.\n\nවිකල්පය: බලන්න අයිකනය ඔබා විස්තරයෙන් «සංස්කරණය» තෝරන්න.\n\nට්‍රක් පවරන්න:\n1. ක්‍රියා මෙනුවෙන් «ට්‍රකයට පවරන්න» තෝරන්න.\n2. ලබා ගත හැකි ට්‍රක් (රියදුරු පවරා නැති) තෝරා තහවුරු කරන්න.\n\nපවරා ගැනීම අවලංගු:\n1. ක්‍රියා මෙනුවෙන් «ට්‍රකයෙන් පවරා ගැනීම අවලංගු» තෝරන්න (පවරා ගැනීම ඇති විට පමණක්).\n2. ක්‍රියාව තහවුරු කරන්න.',
  },
};
